import type { VoiceTypeKey } from '@/src/dal/user-dal'

import type { PostPaymentOnboardingStep } from '../../types'
import type { KnowledgeLevelOptionKey } from './types'

export const DAY_OPTIONS = [1, 2, 3, 4, 5, 6, 7] as const

export interface PostPaymentOnboardingState {
  step: PostPaymentOnboardingStep
  selectedVoiceType: VoiceTypeKey | null
  selectedDaysPerWeek: (typeof DAY_OPTIONS)[number]
  selectedKnowledgeLevel: KnowledgeLevelOptionKey
  additionalNotes: string
  isSigningOut: boolean
}

export type PostPaymentOnboardingAction =
  | { type: 'setStep'; payload: PostPaymentOnboardingStep }
  | { type: 'setSelectedVoiceType'; payload: VoiceTypeKey }
  | { type: 'setSelectedDaysPerWeek'; payload: (typeof DAY_OPTIONS)[number] }
  | { type: 'setSelectedKnowledgeLevel'; payload: KnowledgeLevelOptionKey }
  | { type: 'setAdditionalNotes'; payload: string }
  | { type: 'setIsSigningOut'; payload: boolean }

export const INITIAL_STATE: PostPaymentOnboardingState = {
  step: 'intro',
  selectedVoiceType: null,
  selectedDaysPerWeek: 4,
  selectedKnowledgeLevel: 'beginner',
  additionalNotes: '',
  isSigningOut: false,
}

export function postPaymentOnboardingReducer(
  state: PostPaymentOnboardingState,
  action: PostPaymentOnboardingAction,
): PostPaymentOnboardingState {
  switch (action.type) {
    case 'setStep':
      return { ...state, step: action.payload }
    case 'setSelectedVoiceType':
      return { ...state, selectedVoiceType: action.payload }
    case 'setSelectedDaysPerWeek':
      return { ...state, selectedDaysPerWeek: action.payload }
    case 'setSelectedKnowledgeLevel':
      return { ...state, selectedKnowledgeLevel: action.payload }
    case 'setAdditionalNotes':
      return { ...state, additionalNotes: action.payload }
    case 'setIsSigningOut':
      return { ...state, isSigningOut: action.payload }
    default:
      return state
  }
}
